import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { EfiraSymbol } from './EfiraSymbol';
const SYMBOL = { sm: 'size-6', md: 'size-7', lg: 'size-10' };
const NAME = { sm: 'text-base', md: 'text-lg', lg: 'text-2xl' };
export function Brand({ size = 'md', href, className }) {
    const classes = ['inline-flex items-center gap-2 text-foreground'];
    if (className !== undefined)
        classes.push(className);
    const content = (_jsxs(_Fragment, { children: [_jsx(EfiraSymbol, { className: SYMBOL[size] }), _jsx("span", { className: `font-brand leading-none tracking-tight whitespace-nowrap ${NAME[size]}`, children: "Efira Live" })] }));
    if (href !== undefined) {
        return (_jsx("a", { href: href, className: `${classes.join(' ')} rounded-md no-underline`, "aria-label": "Efira Live - \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u0443\u044E", children: content }));
    }
    return _jsx("span", { className: classes.join(' '), children: content });
}
//# sourceMappingURL=Brand.js.map